import { draggable } from "common";
import { FilterInfoInstance } from './FilterInfoInstance';
import { UserFilterGroupInstance } from "./UserFilterGroupInstance";


export class FilterDragHandler implements draggable.IDragHandler {
    name: string = 'st-view-filter';
    group: UserFilterGroupInstance;
    filter: FilterInfoInstance;

    constructor(group: UserFilterGroupInstance, filter: FilterInfoInstance) {
        this.group = group;
        this.filter = filter;
    }

    start(ev: DragEvent) {
    }

    stop(ev: DragEvent) {
    }
}
